import { FormFieldProps } from '../../form/FormTypes';
import { validateMandatory } from '../../form/FormFieldHelper';
import { useEffect, useRef, useState } from 'react';
import { FormFieldDropdown as FormFieldDropdownProps } from '../../../../component-props';
import { FormfieldContainer } from '@greystar/designsystem';

export const FormFieldDropdown = (props: FormFieldDropdownProps & FormFieldProps): JSX.Element => {
  const ref = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLSelectElement>(null);
  const [valid, setValid] = useState<boolean>(true);
  const [silent, setSilent] = useState<boolean>(true);

  //Init ref to form
  useEffect(() => {
    if (props.id) {
      props.fieldRefs[props.id] = {
        ref,
        isValid,
      };
    }
  }, []);

  const isValid = () => {
    let valid = true;
    const input = inputRef.current;
    if (input) {
      valid &&= validateMandatory({
        mandatory: props.fields.mandatory.value,
        input: inputRef.current,
      });
    }
    setValid(valid);
    inputRef.current?.setCustomValidity(valid ? '' : props.fields.errorMessage.value);
    return valid;
  };

  const onChange = () => {
    setSilent(false);
    isValid();
  };

  const optionParams = new URLSearchParams(props.fields.options.value);
  const entries = [...optionParams.entries()];
  const options = entries.map(([key, value]: [string, string]) => (
    <option key={key} value={key}>
      {value}
    </option>
  ));

  return (
    <FormfieldContainer
      ref={ref}
      id={props.id as string}
      label={props.fields.label.value}
      fieldDescription={props.fields.description.value}
      hasDescription={!!props.fields.description.value}
      fieldHint={props.fields.hint.value}
      hasHint={!!props.fields.hint.value}
      fieldErrorMessage={props.fields.errorMessage.value}
      hasError={!valid && (!props.formSilent || !silent)}
      mandatory={props.fields.mandatory.value}
    >
      <select
        id={props.id as string}
        ref={inputRef}
        name={props.fields.fieldKey.value}
        defaultValue={props.fields.defaultValue.value ?? ''}
        onChange={onChange}
      >
        {props.fields.placeholder.value && (
          <option key={`${props.id}_placeholder`} value="" disabled>
            {props.fields.placeholder.value}
          </option>
        )}
        {options}
      </select>
    </FormfieldContainer>
  );
};
